import { expVal } from '@confluence/feature-experiments';

export function isReactCompilerActiveV1() {
	if (expVal('confluence_enable_react-compiler-runtime-1', 'isEnabled', false)) {
		return true;
	}
	return false;
}

export function isReactCompilerActiveV2() {
	if (expVal('confluence_enable_react-compiler-runtime-2', 'isEnabled', false)) {
		return true;
	}
	return false;
}
